import { z } from 'zod';
/**
 * The two rendered sizes of every stored avatar.
 */ export const AvatarVariantSchema = z.enum([
    'thumbnail',
    'medium'
]);
/**
 * The two encodings every variant is rendered into — WebP for browsers that
 * accept it, JPEG as the universal fallback.
 */ export const AvatarFormatSchema = z.enum([
    'webp',
    'jpeg'
]);
const AvatarRenditionSchema = z.object({
    webp: z.string(),
    jpeg: z.string()
});
/**
 * Avatar Schema — the single wire shape of a user's avatar, shared by the
 * tenant user, the superadmin user and the upload-avatar response.
 *
 * The object-storage keys behind the renditions are deliberately NOT part of
 * this shape. They are raw bucket paths: a client holding them can address the
 * stored objects directly and bypass the authenticated avatar route entirely.
 * The server keeps persisting them (upload and delete need them to clean the
 * bucket up) and strips them on serialization.
 *
 * `mimeType` and `sizeBytes` are optional because avatars uploaded before
 * those fields existed — and the upload-confirm response, which reports only
 * the freshly minted renditions — do not carry them.
 */ export const AvatarSchema = z.object({
    thumbnail: AvatarRenditionSchema,
    medium: AvatarRenditionSchema,
    uploadedAt: z.number(),
    mimeType: z.string().optional(),
    sizeBytes: z.number().optional()
});

//# sourceMappingURL=avatar.schema.js.map